"use client";

import { ThreeDMarquee } from "@/components/common/3d-marquee/3d-marquee";
import {
    ImgWebsiteHero1,
    ImgWebsiteHero10,
    ImgWebsiteHero11,
    ImgWebsiteHero12,
    ImgWebsiteHero13,
    ImgWebsiteHero14,
    ImgWebsiteHero15,
    ImgWebsiteHero16,
    ImgWebsiteHero17,
    ImgWebsiteHero18,
    ImgWebsiteHero19,
    ImgWebsiteHero2,
    ImgWebsiteHero20,
    ImgWebsiteHero21,
    ImgWebsiteHero22,
    ImgWebsiteHero23,
    ImgWebsiteHero24,
    ImgWebsiteHero25,
    ImgWebsiteHero3,
    ImgWebsiteHero4,
    ImgWebsiteHero5,
    ImgWebsiteHero6,
    ImgWebsiteHero7,
    ImgWebsiteHero8,
    ImgWebsiteHero9,
} from "@/lib/images";
import { useEffect, useState } from "react";

function shuffleArray<T>(array: T[]): T[] {
    return [...array].sort(() => Math.random() - 0.5);
}

const staticImages1 = [
        ImgWebsiteHero1,
        ImgWebsiteHero2,
        ImgWebsiteHero3,
        ImgWebsiteHero4,
        ImgWebsiteHero5,
        ImgWebsiteHero6,
];

const staticImages2 = [
        ImgWebsiteHero7,
        ImgWebsiteHero8,
        ImgWebsiteHero9,
        ImgWebsiteHero10,
        ImgWebsiteHero11,
        ImgWebsiteHero12,
];

const staticImages3 = [
        ImgWebsiteHero13,
        ImgWebsiteHero14,
        ImgWebsiteHero15,
        ImgWebsiteHero16,
        ImgWebsiteHero17,
        ImgWebsiteHero18,
];

const staticImages4 = [
        ImgWebsiteHero19,
        ImgWebsiteHero20,
        ImgWebsiteHero21,
        ImgWebsiteHero22,
        ImgWebsiteHero23,
        ImgWebsiteHero24,
        ImgWebsiteHero25,
];

function SideMarqueeSectionWeb() {
    const [shuffledColumns, setShuffledColumns] = useState([
        staticImages1,
        staticImages2,
        staticImages3,
        staticImages4,
    ]);

    useEffect(() => {
        const column1 = shuffleArray(staticImages1);
        const column2 = shuffleArray(staticImages2);
        const column3 = shuffleArray(staticImages3);
        const column4 = shuffleArray(staticImages4);
        setShuffledColumns(shuffleArray([column1, column2, column3, column4]));
    }, []);

    // Custom transition durations for faster scrolling
    const customTransitions = {
        evenColumnDuration: 6, // Faster speed (was 10)
        oddColumnDuration: 9,  // Faster speed (was 15)
    };

    return (
        <div className="lg:flex hidden">
            <ThreeDMarquee
                columns={shuffledColumns}
                wrapperClassName="w-[1450px] scale-[0.45] sm:scale-[0.65] lg:scale-[1.05] 2xl:scale-[1]"
                gridClassName="grid origin-top-center grid-cols-8 xl:grid-cols-6 gap-6 transform"
                gridStyle={{ transform: "rotateX(0deg) rotateY(0deg) rotateZ(0deg)" }}
                imageClassName="border-none"
                transitionDurations={customTransitions}
            />
        </div>
    );
}

export default SideMarqueeSectionWeb; 